// environment.ts
export const environment = {
  production: true,
  apiUrl: 'https://api.queryai.co.uk',
};
